<template>
  <Layout v-loading="isLoading" :element-loading-text="loadingText">
    <template #top>
      <el-row :gutter="10">
        <el-col :span="5.5">
          <Head
            ref="incomeHead"
            :searchConfig="tableData.searchConfig"
            @searchData="searchData"
          />
        </el-col>
        <template v-if="user.role === '1' || user.role === '4'">
          <el-col :span="0.5">
            <div style="height: 36px">
              <div class="headLine"></div>
            </div>
          </el-col>
          <el-col :span="5.5">
            <Head :searchConfig="searchConfig" @collection="collection" />
          </el-col>
        </template>
      </el-row>
    </template>
    <template>
      <Body :headConfig="tableData.headConfig" :tableData="data.content" />
    </template>
    <template #bottom>
      <Foot :total="data.total" @get-data="getPage" />
    </template>
  </Layout>
</template>

<script>
import getBusinessPage from "@/api/getBusinessPage.js";
import getBusinessByDate from "@/api/getBusinessByDate.js";
import getBusiness from "@/api/getBusiness.js";
import Layout from "@/components/Layout";
import Head from "@/components/Table/Head";
import Body from "@/components/Table/Body";
import Foot from "@/components/Table/Foot";
import requstData from "@/mixins/requstData";
import { getLATime, getSameDay, getDay } from "@/utils/time.js";
import { mapState } from "vuex";

export default {
  mixins: [requstData({ content: [], total: 10 }, true)],
  components: {
    Layout,
    Head,
    Body,
    Foot,
  },
  data() {
    return {
      tableData: {
        headConfig: {
          select: false,
          key: "pageId",
          list: [
            { label: "日期", prop: "date", width: "250" },
            { label: "广告请求次数", prop: "yaoqiu" },
            { label: "展示次数", prop: "baoguang" },
            { label: "展示率", prop: "dabiaolv" },
            { label: "点击量", prop: "dianji" },
            { label: "点击率", prop: "dianyuelv" },
            { label: "eCPM", prop: "ecpm" },
            { label: "预估收入", prop: "money" },
          ],
        },
        searchConfig: {
          list: [
            {
              type: "select",
              model: "appId",
              span: 4.5,
              setting: {
                multiple: false,
              },
              options: [],
            },
            {
              type: "button",
              span: 5,
              operation: [
                {
                  type: 1,
                  label: "查询",
                  style: "primary",
                  listeners: "searchData",
                },
              ],
            },
          ],
        },
      },
      searchConfig: {
        list: [
          {
            type: "singleDate",
            model: "date",
            span: 4.5,
            setting: {
              pickerOptions: {
                disabledDate: getDay(getLATime(), 1),
                cellClassName: (a) => {
                  const now = getLATime();
                  const date = new Date(a).getTime();
                  return getSameDay(date, now)
                    ? "la-time-today"
                    : "la-time-default";
                },
              },
            },
            options: [],
          },
          {
            type: "button",
            span: 5,
            operation: [
              {
                type: 1,
                label: "采集",
                style: "primary",
                listeners: "collection",
              },
            ],
          },
        ],
      },
      businessData: [],
      loadingText: "",
    };
  },
  computed: {
    ...mapState("loginUser", ["user"]),
  },
  methods: {
    async requst(params) {
      if (!this.businessData.length) {
        let res = await getBusiness();
        if (res && res.length > 0) {
          this.businessData = res;
          this.tableData.searchConfig.list[0].options = res.map((item) => {
            return {
              label: item.appName,
              value: item.appId,
            };
          });
          let appId = res[0].appId;
          const { query } = this.$route;
          if (query.appId) {
            appId = query.appId;
          }
          this.$refs.incomeHead.setDataInfo("appId", appId);
          this.search["appId"] = appId;
          return await getBusinessPage({ params, ...{ appId } });
        }
      } else {
        return await getBusinessPage(params);
      }
    },
    async collection(data) {
      const { date } = data;
      if (!date) {
        return this.$message({
          showClose: true,
          message: "请选择采集日期",
          type: "error",
        });
      }
      const time = new Date(date);
      const year = time.getFullYear();
      const month = time.getMonth();
      const day = time.getDate();

      this.isLoading = true;
      this.loadingText = "采集中,请等待...";
      const res = await getBusinessByDate({
        year,
        month: month + 1,
        day,
      });
      this.isLoading = false;
      this.loadingText = "";
      if (res) {
        const h = this.$createElement;
        this.$notify({
          title: "数据已采集",
          message: h("div", null, [
            h(
              "p",
              null,
              `采集日期: ${year}-${(month + 1)
                .toString()
                .padStart(2, "0")}-${day}`
            ),
          ]),
          type: "success",
        });
        this.getData();
      }
    },
  },
};
</script>

<style lang="less">
@import "~@/style/mixin.less";

.messageTransfer {
  width: auto;
}

.headLine {
  .self-center(relative);
  width: 1px;
  height: 30px;
  background-color: #b6b9be;
}
</style>
